// BreadcrumbSchema.jsx
'use client'

import { createBreadcrumbSchema } from '@/utils/htmlHead.utils';
import { shopInfoContainer } from '@/containers/shopInfo.container';

/**
 * Component to render the JSON-LD schema for breadcrumbs
 */
export default function BreadcrumbSchema({ items, lang }) {
  if (!items || items.length === 0) return null;
  
  // Make sure all URLs are absolute
  const { baseURL } = shopInfoContainer;
  const breadcrumbItems = items.map(item => ({
    ...item,
    url: item.url.startsWith('http') ? item.url : `${baseURL}${item.url.startsWith('/') ? '' : '/'}${item.url}`
  }));
  
  // Create the breadcrumb schema
  const breadcrumbSchema = createBreadcrumbSchema(breadcrumbItems);
  
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
    />
  );
}